var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.664 8h2.668M8 9.334V6.666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.115 13.22 1.3-1.3a2 2 0 0 0 .586-1.414v-5.84a2.668 2.668 0 0 0-2.668-2.668h-6.67a2.668 2.668 0 0 0-2.667 2.667v6.67a2.668 2.668 0 0 0 2.668 2.668h5.564c.708 0 1.386-.281 1.887-.782",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 14.003v-2.668c0-.737.597-1.334 1.334-1.334h2.668"
  })));
};
export { SvgNote as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZmNhYTY3MGFlZmIxNDc4NGM1NGNmMmUyZTEwNjlkMGUuc3ZnIjs=";